import { AutogenModelBackOfficeReasonCode, AutogenRowBackOfficeReasonCode } from "./autogen/AutogenModelBackOfficeReasonCode";

export class ModelBackOfficeReasonCode extends AutogenModelBackOfficeReasonCode<RowBackOfficeReasonCode> {
	constructor() {
		super(RowBackOfficeReasonCode);
	}
}

export class RowBackOfficeReasonCode extends AutogenRowBackOfficeReasonCode {
}